import { motion } from 'framer-motion';
import { useInView } from '../../home/hooks/useInView';

const clients = [
  {
    icon: 'ri-rocket-line',
    title: '新創公司與創業團隊',
    description: '在創業初期就建立完整的智產權保護，避免未來的法律糾紛，並提升投資人信心。',
    needs: [
      '技術專利的申請與布局',
      '品牌商標的註冊保護',
      '與投資人、合作夥伴的智產權協議',
      '避免侵犯他人智產權的風險評估',
    ],
  },
  {
    icon: 'ri-building-line',
    title: '中小企業',
    description: '協助企業建立智產權管理制度，保護核心技術與品牌，提升市場競爭力。',
    needs: [
      '產品技術的專利保護',
      '品牌商標的全面管理',
      '營業秘密的保護策略',
      '員工與合作廠商的智產權約定',
    ],
  },
  {
    icon: 'ri-palette-line',
    title: '個人創作者、發明人',
    description: '保護您的創意與發明成果，確保您的心血結晶不被他人盜用或侵權。',
    needs: [
      '發明專利的申請與保護',
      '創作著作權的登記與維權',
      '授權合約的審查與談判',
      '侵權行為的處理與求償',
    ],
  },
];

export function TargetClients() {
  const [ref, isInView] = useInView({ threshold: 0.1 });

  return (
    <section className="py-24 bg-gradient-to-br from-[#f8f9fa] to-white">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <motion.span
            initial={{ opacity: 0, y: 10 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="inline-block px-4 py-2 bg-[#2c5282]/10 rounded-full text-sm font-semibold text-[#2c5282] mb-4"
          >
            服務對象
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-4xl md:text-5xl font-bold text-[#1a365d] mb-6"
            style={{ fontFamily: "'Noto Sans TC', sans-serif" }}
          >
            適合哪些對象
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="text-lg text-gray-600 max-w-3xl mx-auto"
          >
            我們專注服務需要智慧財產權保護的創新者與企業
          </motion.p>
        </motion.div>

        <div className="grid lg:grid-cols-3 gap-8">
          {clients.map((client, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.1 * index }}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-[#2c5282] to-[#1a365d] rounded-xl mb-6">
                <i className={`${client.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-[#1a365d] mb-4" style={{ fontFamily: "'Noto Sans TC', sans-serif" }}>
                {client.title}
              </h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                {client.description}
              </p>
              <div className="space-y-3">
                <div className="text-sm font-semibold text-[#2c5282] mb-3">常見需求：</div>
                {client.needs.map((need, idx) => (
                  <div key={idx} className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-[#2c5282] text-lg mt-0.5"></i>
                    <span className="text-sm text-gray-600 leading-relaxed">{need}</span>
                  </div>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}